import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Spacing from '@marvelapp/marvel-ui/spacing';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Heading from '@marvelapp/marvel-ui/heading';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import propTypeEmptyString from 'marketing-website/utils/customPropTypesCheck';
import caseStudiesAssets from 'marketing-website/configs/caseStudies';

import Image from '../../Image';

import generalStyles from './style/general.module.css';

const cx = classNames.bind({ ...generalStyles });

export default function DoubleImageBlock({ name, align, keyName }) {
  const assets = caseStudiesAssets[name];
  const images = assets.doubleImages[keyName];

  const headingProps = {
    tag: 'h3',
    weight: 'semibold',
    size: 'xxxl',
    color: 'black',
  };
  return (
    <Spacing size="m" sizeM="xl" position="topBottom" type="padding">
      <PageWrap>
        <Grid columns={2} size="xl">
          {images.slice(0, 2).map((item, index) => (
            <GridItem key={index} columnSpan={2} columnSpanM={1}>
              <div
                className={cx('imageContainer', align, {
                  last: index === 1,
                  first: index === 0,
                })}
              >
                {item.src && (
                  <Image
                    hasShadow={false}
                    color="snow--d"
                    {...item}
                    useImageTag={true}
                  />
                )}
                {item.copy && (
                  <MaxWidth value={item.maxWidth}>
                    <Heading {...headingProps}>{item.copy}</Heading>
                  </MaxWidth>
                )}
              </div>
            </GridItem>
          ))}
        </Grid>
      </PageWrap>
    </Spacing>
  );
}

DoubleImageBlock.propTypes = {
  name: propTypeEmptyString,
  align: PropTypes.oneOf(['center', 'offset']),
  keyName: PropTypes.string,
};

DoubleImageBlock.defaultProps = {
  align: 'center',
};



// WEBPACK FOOTER //
// ./src/components/modules/ContentBlocks/DoubleImage/index.js